import { ValuationSummary } from '../../damage/models/valuation-summary.model';
import { State } from './state.model';

export class StateResult {
    valuation: ValuationSummary;
    completedStates: Array<string>;
    returnState: State;
    purchaseTimerStartTime: Date;
    purchaseTimerEndTime: Date;
}
